<template>
	<el-drawer
		size="800px"
		custom-class="shop-contact-drawer drawer-template"
		:title="title"
		:visible.sync="visible"
		:append-to-body="true"
		:wrapperClosable="false"
		@closed="handleClose"
	>
		<Tip type="warning">
			修改店铺跟进人后，将更新该店铺下“已有招商跟进”的“推广中”商品的招商都为[店铺跟进人]，“未认领”商品仅能由[店铺跟进人]进行认领
		</Tip>
		<div class="shop-contact-content">
			<div class="shop-contact-title">
				<span class="fz-14 yx-color-text-regular">店铺内商品数</span>
				<span class="title-value fz-14 ml-12">{{ userInfo?.cooperativeProductCount | formatEmpty }}个</span>
				<span class="fz-14 yx-color-text-regular ml-24">原对接人</span>
				<span class="title-value fz-14 ml-12">{{ userInfo?.shopClaimUserName | formatEmpty }}</span>
			</div>
			<div class="flex flex-align-center mt-24">
				<el-input clearable	 v-model="nickname" class="input-contact" placeholder="请输入新对接人"></el-input>
				<el-button class="ml-12" type="primary" @click="search()">搜索</el-button>
			</div>
			<multi-table
				class="muti-table"
				ref="multiTable"
				:distanceTop="0"
				:columns="columns"
				@gePartnerList="gePartnerList"
				:rowClick="singleElection"
				:list="tableData"
				:total="total"
				:page="pageInfo"
				:pageFixed="false"
			>
				<empty slot="empty"></empty>
			</multi-table>
		</div>
		<div class="bott">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit" :loading="btnLoading">提交</el-button>
			</div>
	</el-drawer>
</template>
<script>
import { relateToList } from '@/api/teamManage';
import getColumns from './columns';
import { zsRoleType } from '@/utils/dataMap';
import { setNewShopUser } from '@/api/cooperativeShop'

export default {
	components: {
		
	},
	data() {
		return {
			visible: false,
			title: '修改店铺对接人',
			nickname: '',
			pageInfo: {
				page_size: 10,
				page_index: 1,
			}, //分页
			total: 0,
			tableData: [], // 表格数据
			to_user_id: '', //比对的用户id
			userInfo:{}, // 当前用户信息
			btnLoading: false, // 确定提交按钮的 loading
		};
	},
	provide() {
		return {
			injectUserId: () => this.to_user_id,
		};
	},
	computed: {
		columns() {
			return getColumns(this);
		},
	},
	methods: {
		show(obj){
			this.userInfo = obj;
			this.visible = true;
			this.getList();
		},
		handleClose(){
			this.user_id = '';
			this.to_user_id = '';
			this.visible = false;
		},
		// 搜索
		search() {
			this.pageInfo.page_index = 1;
			this.getList();
		},
		// 获取列表
		async getList() {
			const { nickname, user_id } = this;
			const { code, data: { list = [], page = {} } = {} } = await relateToList({
					nickname,
					user_id,
					delete: 1, //0全部 1未删除 2已删除
					...this.pageInfo,
					user_type: zsRoleType.id,
				});
				this.tableData = list;
				this.total = page.item_total;
		},
		// 分页方法
		gePartnerList(val) {
			this.pageInfo.page_index = val.page_index;
			this.pageInfo.page_size = val.page_size;
			this.getList();
		},
		//表格 选择新对接方法
		singleElection(row){
			this.to_user_id = row.id
		},
		// todo wzj 增加二次弹窗
		async submit(){
			try{
				if(!+this.to_user_id){
					return this.$message.warning('请勾选新的对接人')
				}
				const { outerShopId, platformId, shopClaimUserId: oldClaimUserId  } = this.userInfo;
				await setNewShopUser({
					outerShopId,
					oldClaimUserId,
					newClaimUserId: this.to_user_id,
					platformId
				});
				this.$emit('refresh')
				this.visible = false;
				this.$message.success('操作成功')
			}finally{
				this.btnLoading = false;
			}
		}

	},
};
</script>
<style lang="less" scoped>
/deep/ .el-drawer__body {
	background: #f7f8f9 !important;
}
.shop-contact-content {
	padding: 20px 16px 20px 16px;
	margin-top: 16px;
	border-radius: 8px;
	background: @color-gy1;
}
.title-value {
	color: @color-text-primary;
	font-weight: 500;
}
.input-contact {
	width: 400px;
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
</style>
